"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCertificationDto = instanceOfCertificationDto;
exports.CertificationDtoFromJSON = CertificationDtoFromJSON;
exports.CertificationDtoFromJSONTyped = CertificationDtoFromJSONTyped;
exports.CertificationDtoToJSON = CertificationDtoToJSON;
exports.CertificationDtoToJSONTyped = CertificationDtoToJSONTyped;
const CertificationType_1 = require("./CertificationType");
const CertificationVerificationStatus_1 = require("./CertificationVerificationStatus");
const FileDto_1 = require("./FileDto");
const StoredDocumentDto_1 = require("./StoredDocumentDto");
/**
 * Check if a given object implements the CertificationDto interface.
 */
function instanceOfCertificationDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    return true;
}
function CertificationDtoFromJSON(json) {
    return CertificationDtoFromJSONTyped(json, false);
}
function CertificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': (0, CertificationType_1.CertificationTypeFromJSON)(json['code']),
        'expiration': json['expiration'] == null ? undefined : (new Date(json['expiration'])),
        'certificationCode': json['certificationCode'] == null ? undefined : json['certificationCode'],
        'ahaECardCode': json['ahaECardCode'] == null ? undefined : json['ahaECardCode'],
        'rqiCertificateCode': json['rqiCertificateCode'] == null ? undefined : json['rqiCertificateCode'],
        'holderName': json['holderName'] == null ? undefined : json['holderName'],
        'ignoreMismatchedName': json['ignoreMismatchedName'] == null ? undefined : json['ignoreMismatchedName'],
        'certificationCard': json['certificationCard'] == null ? undefined : (0, FileDto_1.FileDtoFromJSON)(json['certificationCard']),
        'document': json['document'] == null ? undefined : (0, StoredDocumentDto_1.StoredDocumentDtoFromJSON)(json['document']),
        'requiredForProfile': json['requiredForProfile'] == null ? undefined : json['requiredForProfile'],
        'requiredForSpecialty': json['requiredForSpecialty'] == null ? undefined : json['requiredForSpecialty'],
        'verificationDate': json['verificationDate'] == null ? undefined : (new Date(json['verificationDate'])),
        'verificationStatus': json['verificationStatus'] == null ? undefined : (0, CertificationVerificationStatus_1.CertificationVerificationStatusFromJSON)(json['verificationStatus']),
    };
}
function CertificationDtoToJSON(json) {
    return CertificationDtoToJSONTyped(json, false);
}
function CertificationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': (0, CertificationType_1.CertificationTypeToJSON)(value['code']),
        'expiration': value['expiration'] == null ? undefined : (value['expiration'].toISOString().substring(0, 10)),
        'certificationCode': value['certificationCode'],
        'ahaECardCode': value['ahaECardCode'],
        'rqiCertificateCode': value['rqiCertificateCode'],
        'holderName': value['holderName'],
        'ignoreMismatchedName': value['ignoreMismatchedName'],
        'certificationCard': (0, FileDto_1.FileDtoToJSON)(value['certificationCard']),
        'document': (0, StoredDocumentDto_1.StoredDocumentDtoToJSON)(value['document']),
        'requiredForProfile': value['requiredForProfile'],
        'requiredForSpecialty': value['requiredForSpecialty'],
        'verificationDate': value['verificationDate'] == null ? undefined : (value['verificationDate'].toISOString().substring(0, 10)),
        'verificationStatus': (0, CertificationVerificationStatus_1.CertificationVerificationStatusToJSON)(value['verificationStatus']),
    };
}
//# sourceMappingURL=CertificationDto.js.map